import * as yup from 'yup';
import { enabledValidation } from 'utils/yup';
import { TFunction } from 'i18next';

export default (t: TFunction): any =>
  yup.object({
    deliveryEnabled: enabledValidation(t),
    pickUpEnabled: enabledValidation(t),
    isLocalDelivery: enabledValidation(t),
    showPhoneField: enabledValidation(t),
    isPhoneFieldRequired: yup.mixed().when('showPhoneField', {
      is: true,
      then: enabledValidation(t),
    }),
    pickUpVerificationMethod: yup.number().nullable(),
    areas: yup
      .array()
      .of(
        yup.object().shape({
          id: yup.string(),
          description: yup.string().required(t('schema-venueDeliveryConfig-form-areas-description')),
          fields: yup.array().min(1, t('schema-venueDeliveryConfig-form-areas-fields')),
        }),
      )
      .when('deliveryEnabled', {
        is: true,
        then: (schema) => schema.min(1, t('schema-venueDeliveryConfig-form-areas-min')),
        otherwise: (schema) => schema.notRequired(),
      }),
  });
